import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
// import TagsInput from "react-tagsinput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import errorsType from "../types/errorsType";
import tooltips from "./tooltips";
import {
  SectionTitle,
  Field,
  Label,
  LabelText,
  LabelIcon,
  Required,
  MustHavesInputWrapper,
  Error,
} from "../styles/edit-form-styles";
import DraggableTagsInput from "../../shared/general/draggable_tags/DraggableTagsInput";

class MustHaves extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
    };
  }

  componentDidMount() {
    this.convertMustHaves();
  }

  componentWillUnmount() {
    this.convertMustHaves();
  }

  convertMustHaves = () => {
    const { keySkills } = this.props;
    const currentMustHaves = keySkills ? keySkills.split(",").map((s) => s.trim()) : [];
    this.setState({ tags: currentMustHaves });
  };

  handleChange = (tags) => {
    const { mustHavesOnChange } = this.props;

    this.setState({ tags });
    mustHavesOnChange(tags);
  };

  render() {
    const { tags } = this.state;
    const { errors } = this.props;

    return (
      <Fragment>
        <SectionTitle>Must Haves</SectionTitle>
        <Field>
          <Label htmlFor="job-title">
            <LabelText>
              Must Haves
              <Required>*</Required>
            </LabelText>
            <LabelIcon>
              <FontAwesomeIcon
                data-tip={tooltips.mustHaves}
                data-for="must-haves-tooltip"
                icon={faInfoCircle}
              />
              <ReactTooltip
                place="left"
                type="dark"
                effect="solid"
                aria-haspopup="true"
                id="must-haves-tooltip"
              />
            </LabelIcon>
          </Label>
          <MustHavesInputWrapper>
            <DraggableTagsInput
              error={!!errors.key_skills}
              value={tags}
              onChange={this.handleChange}
              placeholder="Add new..."
            />
          </MustHavesInputWrapper>
          {errors.key_skills && tags.length === 0 && <Error>Must haves cannot be blank</Error>}
        </Field>
      </Fragment>
    );
  }
}

MustHaves.propTypes = {
  keySkills: PropTypes.string.isRequired,
  mustHavesOnChange: PropTypes.func.isRequired,
  errors: errorsType.isRequired,
};

export default MustHaves;
